import { useQuery } from "@tanstack/react-query";
import { getApiAiUsage } from "Infrastructure/Api/Api";

export const AI_USAGE_QUERY_KEY = "AI_USAGE_QUERY";

export function useAiUsageQuery() {
	return useQuery({
		queryKey: [AI_USAGE_QUERY_KEY],
		queryFn: () => getApiAiUsage(),
		staleTime: Infinity,
		refetchOnWindowFocus: false,
	});
}
